import EventCard from "../../../../ReusableComponent/EventCard";

const UpcomingSection = () => {
  const tournaments = [
    {
      category: "tournament",
      title: "Monthly Mega Contest",
      date: "March 15, 2024",
      time: "8:00 PM IST (3 hours)",
      participants: 5000,
      prize: "$15,000",
      sponsoredBy: "TechCorp",
      problems: 6,
      difficulty: "Hard",
    },
    {
      category: "tournament",
      title: "Frontend Challenge",
      date: "March 20, 2024",
      time: "6:00 PM IST (2 hours)",
      participants: 2500,
      prize: "$8,000",
      sponsoredBy: "WebDev Pro",
      problems: 4,
      difficulty: "Medium",
    },
    {
      category: "tournament",
      title: "Data Structure Sprint",
      date: "March 25, 2024",
      time: "7:00 PM IST (90 min)",
      participants: 3200,
      prize: "$6,000",
      sponsoredBy: "CodeAcademy",
      problems: 5,
      difficulty: "Easy",
    },
  ];

  return (
    <section className="row mx-0 py-5 d-flex justify-content-center align-items-center">
      <div className="col-md-11 col-12">
        <div className="row mx-0 d-flex justify-content-center align-items-center">
          <div className="col-12 text-center mb-3">
            <h3 className="text-center text-light fw-bold mb-5">
              Upcoming Tournaments
            </h3>
          </div>
          {tournaments.map((event, idx) => (
            <EventCard key={idx} {...event} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default UpcomingSection;
